export default __webpack_public_path__ + "static/media/afspuitplaats.18c0c6bf.svg";